import {Stack, Typography} from '@mui/material';
import {get} from 'lodash';
import {AppAny} from '../../../shared/types/common.types';
import {DaDataSuggestion} from '../../../shared/types/daData.types';

export const getServiceRequestDto = (data: AppAny) => ({
  ...data,
  description: data?.description ? data?.description.trim() : '',
  res: data?.res ? data?.res.trim() : null,
});

export const getServiceRequestDtoNew = (data: AppAny) => ({
  ...data,
  customers: Array.isArray(data?.customers)
    ? data.customers.map((customer: AppAny) => ({
        uid: customer?.uid ?? customer?.id ?? null,
      }))
    : [],
  description: data?.description ? data?.description.trim() : '',
  res: data?.res ? data?.res.trim() : null,
  address: {
    fullAddress: get(data, 'address.unrestricted_value'),
    cadastre: get(data, 'address.data.house_cadnum'),
    latitude: get(data, 'address.data.geo_lat'),
    longitude: get(data, 'address.data.geo_lon'),
  },
});

export const validateAddress = (address: DaDataSuggestion) => {
  if (!address) return 'Укажите адрес';
  if (!address.unrestricted_value) return 'Укажите адрес';
  if (!get(address, 'unrestricted_value')) return 'Укажите адрес';
  if (!get(address, 'data.region')) return 'Укажите регион';
  if (!get(address, 'data.city') && !get(address, 'data.settlement')) return 'Укажите населенный пункт';
};

export const renderNonOptionsText = (text: string) => {
  return (
    <Stack direction="column" spacing={3}>
      <Typography variant="body2" sx={{color: (t) => t.palette.text.secondary, whiteSpace: 'wrap'}}>
        {text}
      </Typography>
    </Stack>
  );
};
